export type OverlayGeometry =
  | google.maps.Polygon
  | google.maps.Rectangle
  | google.maps.Circle

export interface DrawResult {
  type: google.maps.drawing.OverlayType
  overlay: OverlayGeometry
}

export interface Snapshot {
  radius?: number
  center?: google.maps.LatLngLiteral
  position?: google.maps.LatLngLiteral
  path?: Array<google.maps.LatLng>
  bounds?: google.maps.LatLngBoundsLiteral
}

export interface Overlay {
  type: google.maps.drawing.OverlayType
  geometry: OverlayGeometry
  snapshot: Snapshot
}

export interface DrawingState {
  past: Array<Array<Overlay>>
  now: Array<Overlay>
  future: Array<Array<Overlay>>
}

export function isCircle(
  overlay: OverlayGeometry,
): overlay is google.maps.Circle {
  return (overlay as google.maps.Circle).getCenter !== undefined
}

export function isPolygon(
  overlay: OverlayGeometry,
): overlay is google.maps.Polygon {
  return (overlay as google.maps.Polygon).getPath !== undefined
}

export function isRectangle(
  overlay: OverlayGeometry,
): overlay is google.maps.Rectangle {
  return (overlay as google.maps.Rectangle).getBounds !== undefined
}
